import getConfig from 'next/config';

export function getHost(host) {
  const { publicRuntimeConfig } = getConfig();
  return publicRuntimeConfig.endpoints[host];
}
